import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import './Detail.css'
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faShoppingCart, faExternalLinkAlt, faStar, faHeart } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from "react-router-dom";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { safeGet, safeSet, safeRemove, safeJsonParse, getSafeSession } from '../utils/browserSafe';
import baseURL from '../url';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DetailLoading from "../DetailLoading/DetailLoading";
import moneda from '../moneda';
import { fetchGeoInfo, getGeoCountryParam, productWithDisplayPrice, filterProductByVisibility } from '../Geo/geoPricing';

function animateFlyToCart(imageSrc, sourceElement) {
    const cartButton = document.querySelector('.cartIconFixed');
    if (!cartButton || !sourceElement) return;

    const sourceRect = sourceElement.getBoundingClientRect();
    const cartRect = cartButton.getBoundingClientRect();

    const flyer = document.createElement('img');
    flyer.src = imageSrc || '';
    flyer.className = 'flyToCartClone';
    flyer.style.left = `${sourceRect.left + sourceRect.width / 2 - 25}px`;
    flyer.style.top = `${sourceRect.top + sourceRect.height / 2 - 25}px`;
    document.body.appendChild(flyer);

    requestAnimationFrame(() => {
        flyer.style.transform = `translate(${cartRect.left - sourceRect.left}px, ${cartRect.top - sourceRect.top}px) scale(0.2)`;
        flyer.style.opacity = '0.2';
    });

    setTimeout(() => {
        if (flyer.parentNode) flyer.parentNode.removeChild(flyer);
    }, 700);
}

export default function Detail() {
    const navigate = useNavigate();
    const swiperRef = useRef(null);
    SwiperCore.use([Navigation, Pagination, Autoplay]);
    const { idProducto } = useParams();
    const [producto, setProducto] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState("");
    const [cantidad, setCantidad] = useState(1);
    const [productos, setProductos] = useState([]);
    const [contactos, setContactos] = useState([]);
    const [favoritos, setFavoritos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [selectedItemIndex, setSelectedItemIndex] = useState(0);
    const [buttonAnimating, setButtonAnimating] = useState(false);
    const [geoInfo, setGeoInfo] = useState(null);
    const location = useLocation();

    const items = [producto?.item1, producto?.item2, producto?.item3, producto?.item4, producto?.item5, producto?.item6, producto?.item7, producto?.item8, producto?.item9, producto?.item10].filter(Boolean);

    useEffect(() => {
        fetchGeoInfo().then((info) => {
            setGeoInfo(info);
            cargarProductos(info);
        });
        cargarContacto();
        cargarFavoritos();
        cargarCategoria();
        if (items.length > 0) {
            setSelectedItemIndex(0);
        }
    }, []);

    const handleSelectionChange = (index) => {
        setSelectedItemIndex(index);
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(error => console.error('Error al cargar categorías:', error));
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(response => response.json())
            .then(data => setContactos(data.contacto.reverse()[0] || []))
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cargarProductos = (geo = geoInfo) => {
        const countryParam = geo?.countryCode ? `?country=${encodeURIComponent(geo.countryCode)}` : getGeoCountryParam();
        fetch(`${baseURL}/productosGet.php${countryParam}`, { method: 'GET' })
            .then(response => response.json())
            .then(data => {
                const list = (data.productos || [])
                    .filter(item => filterProductByVisibility(item, geo))
                    .map(item => productWithDisplayPrice(item, geo));
                setProductos(list);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const cargarFavoritos = () => {
        const storedFavoritos = safeJsonParse(safeGet('favoritos','[]'), []);
        setFavoritos(storedFavoritos);
    };

    useEffect(() => {
        const product = productos.find((e) => e.idProducto === parseInt(idProducto));
        setProducto(product);
    }, [idProducto, productos]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function handleCompartirClick() {
        if (navigator.share) {
            navigator.share({
                title: document.title,
                text: 'Echa un vistazo a este producto',
                url: window.location.href,
            }).catch((error) => console.error('Error al compartir:', error));
        }
    }

    const goBack = () => {
        if (location.key !== 'default') navigate(-1);
        else navigate('/');
    };

    const addToCart = (selectedItem, event) => {
        if (!producto) return;

        if (Number(producto.stockEnabled || 0) === 1 && Number(producto.stockQty || 0) < 1) {
            toast.error('No hay stock', { autoClose: 500 });
            return;
        }

        const cart = safeJsonParse(safeGet('cart','[]'), []);
        const existingItemIndex = cart.findIndex(item => item.idProducto === producto.idProducto);

        if (existingItemIndex !== -1) {
            const existingItem = cart[existingItemIndex];
            const updatedCantidad = existingItem.cantidad + cantidad;
            cart[existingItemIndex] = { ...existingItem, item: selectedItem ? [selectedItem] : existingItem.item, variante: selectedItem || existingItem.variante || '', cantidad: updatedCantidad };
        } else {
            cart.push({ idProducto: producto.idProducto, item: selectedItem ? [selectedItem] : [], variante: selectedItem || '', cantidad });
        }

        safeSet('cart', JSON.stringify(cart));
        window.dispatchEvent(new Event('cartUpdated'));
        window.dispatchEvent(new Event('cartBounce'));

        const sourceEl = document.querySelector('#swiperDetail img') || event?.currentTarget;
        animateFlyToCart(producto.imagen1 || producto.imagen2 || producto.imagen3 || producto.imagen4, sourceEl);

        setButtonAnimating(true);
        setTimeout(() => setButtonAnimating(false), 350);

        // Sin toast de éxito para evitar el conflicto con react-toastify en esta instalación.
    };

    const incrementCantidad = () => setCantidad(cantidad + 1);
    const decrementCantidad = () => { if (cantidad > 1) setCantidad(cantidad - 1); };

    const agregarAFavoritos = (idProducto) => {
        const favList = [...favoritos];
        const index = favList.indexOf(idProducto);
        if (index === -1) {
            favList.push(idProducto);
            setFavoritos(favList);
            safeSet('favoritos', JSON.stringify(favList));
        } else {
            favList.splice(index, 1);
            setFavoritos(favList);
            safeSet('favoritos', JSON.stringify(favList));
        }
    };

    if (!producto) return <DetailLoading />;

    const relatedProducts = productos
        .filter(p => p.idProducto !== producto.idProducto && Number(p.activo ?? 1) === 1 && (p.idCategoria === producto.idCategoria || Number(p.salesCount || 0) > 0))
        .sort((a,b)=>Number(b.salesCount||0)-Number(a.salesCount||0))
        .slice(0, 8);

    return (
        <div className="detail">
            <ToastContainer />
            <div className="deFlexDetail">
                <button className="back" onClick={goBack}> <FontAwesomeIcon icon={faArrowLeft} /> </button>
                <div className="deFLexIcon">
                    <button onClick={() => agregarAFavoritos(producto.idProducto)} className='favoritos-btn'>
                        <FontAwesomeIcon icon={faHeart} style={{ color: favoritos.includes(producto.idProducto) ? 'red' : 'gray' }} />
                    </button>
                    <button className="share" onClick={handleCompartirClick}> <FontAwesomeIcon icon={faExternalLinkAlt} /> </button>
                </div>
            </div>

            <div className="detail-contain">
                <SwiperSlide id={"swiperDetail"} >
                    <Swiper
                        effect={'coverflow'}
                        grabCursor={true}
                        loop={true}
                        slidesPerView={'auto'}
                        coverflowEffect={{ rotate: 0, stretch: 0, depth: 100, modifier: 2.5 }}
                        navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }}
                        autoplay={{ delay: 3000 }}
                        pagination={{ clickable: true }}
                        onSwiper={(swiper) => { swiperRef.current = swiper; }}
                    >
                        {producto.imagen1 && <SwiperSlide><img src={producto.imagen1} alt={producto.titulo} className="imagen1" onClick={() => { setModalImage(producto.imagen1); setIsModalOpen(true); }} /></SwiperSlide>}
                        {producto.imagen2 && <SwiperSlide><img src={producto.imagen2} alt={producto.titulo} className="imagen2" onClick={() => { setModalImage(producto.imagen2); setIsModalOpen(true); }} /></SwiperSlide>}
                        {producto.imagen3 && <SwiperSlide><img src={producto.imagen3} alt={producto.titulo} className="img" onClick={() => { setModalImage(producto.imagen3); setIsModalOpen(true); }} /></SwiperSlide>}
                        {producto.imagen4 && <SwiperSlide><img src={producto.imagen4} alt={producto.titulo} className="imagen4" onClick={() => { setModalImage(producto.imagen4); setIsModalOpen(true); }} /></SwiperSlide>}
                    </Swiper>
                </SwiperSlide>

                <div className="textDetail">
                    <h2 className="title">{producto.titulo}</h2>
                    <hr />
                    <div className="deFLexBuet">
                        {categorias
                            .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                            .map(categoriaFiltrada => (
                                <h4 key={categoriaFiltrada.idCategoria}><FontAwesomeIcon icon={faStar} />{categoriaFiltrada.categoria}</h4>
                            ))
                        }
                        {Number(producto.stockEnabled || 0) === 1 && Number(producto.stockQty || 0) <= 0 ? (
                            <h4 style={{ color: 'red', backgroundColor: '#ffc1c1', padding: '0px 10px', borderRadius: '6px' }}>Agotado</h4>
                        ) : Number(producto.stockEnabled || 0) === 1 && Number(producto.stockQty || 0) <= Number(producto.lowStockAlert || 3) ? (
                            <h4 style={{ color: '#a54800', backgroundColor: '#fff3cd', padding: '0px 10px', borderRadius: '6px' }}>🔥 Quedan {producto.stockQty} unidades</h4>
                        ) : Number(producto.stockEnabled || 0) === 1 ? (
                            <h4 style={{ color: 'green', backgroundColor: '#ccffcc', padding: '0px 10px', borderRadius: '6px' }}>Stock {producto.stockQty}</h4>
                        ) : null}
                    </div>

                    <div className='deFLexPrice'>
                        <h5 className="price">{moneda} {producto?.precio}</h5>
                        {(producto?.precioAnterior >= 1 && producto?.precioAnterior !== undefined) && (
                            <h5 className='precioTachadoDetail'>{moneda} {producto?.precioAnteriorDisplay || producto?.precioAnterior}</h5>
                        )}
                    </div>

                    <p>{producto.descripcion}</p>

                    <div className='itemsDetail variantSelectWrap'>
                        {producto && items.length > 0 && (
                            <label className='variantSelectLabel'>
                                <span>Variante:</span>
                                <select value={selectedItemIndex} onChange={(e) => handleSelectionChange(Number(e.target.value))}>
                                    {items.map((item, index) => (
                                        <option key={index} value={index}>{item}</option>
                                    ))}
                                </select>
                            </label>
                        )}
                    </div>

                    <div className='deFlexCart'>
                        <button onClick={decrementCantidad}>-</button>
                        <span>{cantidad}</span>
                        <button onClick={incrementCantidad}>+</button>
                    </div>

                    <div className='deFlexGoTocart'>
                        <button
                            onClick={(e) => addToCart(items[selectedItemIndex], e)}
                            className={`btnAdd ${buttonAnimating ? 'btnAddSuccess btnAddPulse' : ''}`}
                            type="button"
                        >
                            Agregar <FontAwesomeIcon icon={faShoppingCart} />
                        </button>
                    </div>
                </div>
            </div>

            {relatedProducts.length > 0 && (
                <section className="relatedProducts">
                    <h3>Clientes también compraron…</h3>
                    <div className="relatedGrid">
                        {relatedProducts.map((p) => (
                            <div className="relatedCard" key={p.idProducto} onClick={() => navigate(`/producto/${p.idProducto}/${p.titulo.replace(/\s+/g, '-')}`)}>
                                <img src={p.imagen1 || p.imagen2 || p.imagen3 || p.imagen4} alt={p.titulo} />
                                <strong>{p.titulo}</strong>
                                <span>{moneda} {p.precio}</span>
                            </div>
                        ))}
                    </div>
                </section>
            )}

            <Modal
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                center
                classNames={{ modal: 'custom-modal' }}
            >
                <img src={modalImage} alt={producto.titulo} />
            </Modal>
        </div>
    )
}
